import { getMenuList } from '@/api/login'
import { resetRouter } from '@/router'

/**
 * 
 * @description 重写trim方法，去除字符串首尾指定字符
 * @param {String} char 删除的字符
 * @param {String} type 左右位置，值为left、right，不传则是首尾两端
 */
function rewriteTrim () {
  String.prototype.trim = function (char, type) {
    if (char) {
        if (type == 'left') {
            return this.replace(new RegExp('^\\'+char+'+', 'g'), '')
        } else if (type == 'right') {
            return this.replace(new RegExp('\\'+char+'+$', 'g'), '')
        }
        return this.replace(new RegExp('^\\'+char+'+|\\'+char+'+$', 'g'), '')
    }
    return this.replace(/^\s+|\s+$/g, '')
  }
}

const formatList = (menu) => {
  menu.map(item => {
    if (!item.resourceUrl && item.child.length) {
      const childUrl = item.child[0].resourceUrl.trim('/').split('/')
      item.resourceUrl = childUrl[0]
      let childMenu = []
      item.child.map(itemSon => {
        if (itemSon.parentId === item.id) {
          const childUrl = itemSon.resourceUrl.trim('/').split('/')
          childMenu.push(childUrl[childUrl.length - 1])
        }
      })
      item.childMenu = childMenu
    }
  })
  return menu
}

const filterRoutes = (menu, routes) => {
  const menuList = formatList(menu)
  const menuNameList = menu.map(item => item.resourceUrl)
  routes = routes.filter(item => menuNameList.includes(item.name))
  return routes.map(item => {
    const childRoute = item.children
    let childMenu
    menuList.map(value => {
      if (value.resourceUrl === item.name) childMenu = value
    })
    item.children = childRoute.filter(value => childMenu.childMenu.includes(value.name))
    return item
  })
}

export default {
  namespaced: true,
  state: {
    routes: [],
    menuRoutes: [],
    hasPermission: false,
    menuType: undefined, // 菜单类型：undefined: 订单管理 shop:能+营销
    hasMarketRight: false, // 是否有能+权限
    hasFund: false, // 是否有营销基金权限
    hadBtn: [], // 是否有按钮权限
    loginPlatform: sessionStorage.getItem('loginPlatform')
  },
  getters: {},
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.routes = routes
    },
    SET_PERMISSION: (state, payload) => {
      state.hasPermission = payload.type
      state.menuRoutes = payload.needRoutes
    },
    CLEAR_PERMISSION: (state) => {
      state.hasPermission = false
      state.menuRoutes = []
      state.hasMarketRight = false
    },
    CHANGE_MENU: (state, payload) => {
      state.menuType = payload
    },
    SET_ORDER_MENU: (state, { type, hasMarketRight }) => {
      state.menuType = type
      state.hasMarketRight = hasMarketRight
    },
    SET_FUND: (state, { hasFund }) => {
      state.hasFund = hasFund
    },
    SET_BTN: (state, { hadBtn }) => {
      state.hadBtn = hadBtn
    },
    SET_LOGINPLATFORM: (state, data) => {
      sessionStorage.setItem('loginPlatform', data)
      state.loginPlatform = data
    }
  },
  actions: {
    generateRoutes ({commit}, routes) {
      commit('SET_ROUTES', routes)
    },
    async getNewRoute ({ state, commit }) {
      try {
        const {code, result} = await getMenuList()
        if (code !== 200) {
          // 防止路由守卫陷入死循环，返回[]
          commit('SET_PERMISSION', { needRoutes: [], type: false })
          return []
        }
        
        // 重写trim方法，未防止trim被反重写，每次获取权限时都需要调用该方法
        rewriteTrim()
        
        // 判断按钮权限, 并且把所有的按钮resourceCode过滤出来
        const btnList = result.map(item => item.child.filter(itemChild => itemChild.child && itemChild.child.length)).flat().map(item => item.child.map(itemChild => itemChild.resourceCode)).flat()
        commit('SET_BTN', { hadBtn: btnList })

        let needRoutes = filterRoutes(result, state.routes)
        // 判断是否有能+商城权限
        const hasMarketRight = needRoutes.find(item => item.meta && item.meta.type === 'shop')
        // 判断是否有营销基金权限
        const hasFund = needRoutes.find(item => item.path === '/fund')
        commit('SET_ORDER_MENU', { type: undefined, hasMarketRight })
        if (hasFund) commit('SET_FUND', { hasFund: true })
        commit('SET_PERMISSION', {needRoutes, type: true})
        return needRoutes
      } catch (err) {
        console.log(err)
      }
    },
    resetPermission ({commit}) {
      resetRouter()
      commit('CLEAR_PERMISSION')
    },
    changeMenu ({commit}, menuType) {
      commit('CHANGE_MENU', menuType)
    },
    setPlatform ({commit}, data) {
      commit('SET_LOGINPLATFORM', data)
    }
  }
}
